import styled, { keyframes } from "styled-components";

export const TooltipRow = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing.xSmall,
}));

export const LeftTriggerArea = styled.div({
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
});

export const LeftColumn = styled.div(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    borderBottom: "1px dashed",
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));

export const InfoText = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    width: "75%",
}));

export const RowInfoText = styled.div(({ theme }) => ({
    float: "right",
    marginTop: theme.spacing.xxSmall,
}));

const ARROW_TRIANGLE_LENGTH = 6;

const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const FadeInDiv = styled.div`
    animation: ${fadeIn} 0.1s ease-in;
`;

export const TooltipContainer = styled(FadeInDiv)(({ theme }) => ({
    position: "fixed",
    top: `${-ARROW_TRIANGLE_LENGTH}px`,
    left: `calc(${theme.spacing.xxLarge} * -1)`,
    zIndex: 1000,
    padding: `${theme.spacing.x11} ${theme.spacing.medium}`,
    background: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.small,
    boxShadow: "0px 1px 16px rgba(2, 6, 12, 0.08)",
}));

export const TooltipArrowBefore = styled.div(({ theme }) => ({
    position: "absolute",
    bottom: "-3px",
    width: "14px",
    height: "14px",
    background: theme.colors[theme.colorMode].background_Primary,
    transform: "rotate(-60deg) skew(-30deg)",
    boxShadow: "0px 1px 16px rgba(0,0,0,.05)",
    zIndex: 1,
}));

export const TooltipArrowAfter = styled.div(({ theme }) => ({
    position: "absolute",
    bottom: "0",
    width: "25px",
    height: "16px",
    background: theme.colors[theme.colorMode].background_Primary,
    zIndex: 2,
}));

export const SubLineRow = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: theme.spacing.small,
}));

export const SubLineTitleRow = styled.div(({ theme }) => ({
    paddingBottom: theme.spacing.xxSmall,
    marginLeft: 0,
    wordBreak: "break-word",
}));

export const SubLineDescription = styled.p(() => ({
    maxWidth: "80%",
    marginTop: "3px",
    whiteSpace: "pre-line",
}));

export const SubLineDescriptionTextSegment = styled.span({
    marginRight: "2px",
});
